import brass from "./resource/brass.jpg";
import edwin from "./resource/edwin.jpg"
import event from "./resource/upcomingevent.jpg"
const EventData = [
    {
      id: '1',
      title: 'Cinematic SoundScapes From Screen to Symphony @ Toa Payoh West CC',
      content: 'Event: 8 March 2026',
      price:'Admission: Free',
      image: event,
    },
    // {
    //   id: '2',
    //   title: 'Dummy Content Symphony Surprise 2024 @ Esplanade',
    //   content: 'Here’s some more content in the second post.',
    //   image: edwin,
    // },
    // {
    //   id: '3',
    //   title: 'Dummy Content Performance 2024 @ Toa',
    //   content: 'Content for blog post number three!',
    //   image: brass,
    // },
  ];
  
  export default EventData;